import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CardFrame from './atoms/CardFrame';
import { useGetEmailInvitationsQuery, RootState } from '../store';
import Button from './atoms/Button';

const InvitationNotification: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { data: invitations } = useGetEmailInvitationsQuery({ email: user?.email }, { skip: !user || !user.email });
  const navigate = useNavigate();
  const filteredInvitations = invitations?.filter((invitation) => invitation.status === 'pending');
  return (
    <>
      {filteredInvitations && filteredInvitations.length > 0 && <CardFrame className="min-h-[200px] flex items-center justify-center">
        <div className="flex flex-col items-center justify-center h-full text-center">
          <h1 className="text-text-primary text-2xl">¡Tenés invitaciones pendientes!</h1>
          <p className="text-text-primary">Dirigite al panel de invitaciones para hacer la revisión correspondiente</p>
          <div className="w-fit mt-4">
            <Button variant="primary" onClick={() => navigate('/admin/invitations')} className="w-fit">
              Ir a invitaciones
            </Button>
          </div>

        </div>
      </CardFrame>}
    </>
  );
};

export default InvitationNotification;
